import HashtagTableHelper from './hashtag-table-helper';
import HashtagFollowersTableHelper from './hashtag-followers-table-helper';


const HashtagHelpers = {
    TableMain: HashtagTableHelper,
    TableFollowers: HashtagFollowersTableHelper,
}

export default HashtagHelpers;